import { render, staticRenderFns } from "./ActivityEntry.vue?vue&type=template&id=c0bfe01a&scoped=true&"
import script from "./ActivityEntry.vue?vue&type=script&lang=js&"
export * from "./ActivityEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bfe01a",
  null
  
)

export default component.exports